// import React from "react"
// import { Link } from "react-router-dom"
// import "./MovieList.css"
// import "../layout/Button.css"

// function MovieList({ movieList, lastMovieRef }) {
//   return (
//     <ul className="movieList-main-details">
//       {movieList &&
//         movieList.map((movie) => (
//           <li key={movie.id} className="movie-data-container">
//             <MovieTitle movie={movie} />
//             <div className="list-movie-details-container">
//               <MoviePoster movie={movie} />
//               <div className="movie-details">
//                 <MovieLabels movie={movie} />
//                 <MovieButtons movie={movie} />
//               </div>
//             </div>
//           </li>
//         ))}
//     </ul>
//   )
// }

// export default MovieList

// function MovieTitle({ movie }) {
//   return (
//     <div className="movie-title-container">
//       <p className="movie-title">
//         <Link to={`/movie/${movie.id}`}>{movie.title}</Link>
//       </p>
//     </div>
//   )
// }

// function MoviePoster({ movie }) {
//   return (
//     <div className="movie-poster">
//       <img
//         className="img-cover"
//         src={"https://image.tmdb.org/t/p/w500/" + movie.poster_path}
//         alt={movie.title}
//         onError={(e) => {
//           e.target.onerror = null
//           e.target.src = "./assets/default.png"
//         }}
//       />
//     </div>
//   )
// }

// function MovieLabels({ movie }) {
//   return (
//     <div className="labels">
//       <p className="detail">
//         <span className="label">Director:</span> {movie.director}
//       </p>
//       <p className="detail">
//         <span className="label">Genre:</span> {movie.genre}
//       </p>
//       <p className="detail">
//         <span className="label">Country:</span> {movie.country}
//       </p>
//       <p className="detail">
//         <span className="label">Duration:</span> {movie.duration}
//       </p>
//       <p className="detail">
//         <span className="label">In your album:</span> {movie.album}
//       </p>
//       <p className="detail">
//         <span className="label">Favorite:</span> {movie.favorite ? "Yes" : "No"}
//       </p>
//     </div>
//   )
// }

// function MovieButtons({ movie }) {
//   return (
//     <div className="movie-buttons">
//       <Link to={`/movie/${movie.id}`} className="btn ifelt-button">
//         View Profile
//       </Link>
//       <Link to={`/classify/${movie.id}`} className="btn ifelt-button">
//         Classify
//       </Link>
//     </div>
//   )
// }

import React from "react"
import { Link } from "react-router-dom"
import "./MovieList.css"
import "../layout/button.css"

function MovieList({ movieList }) {
  return (
    <ul className="movieList-main-details">
      {movieList &&
        movieList.map((movie) => (
          <li key={movie.id} className="movie-data-container">
            <MovieTitle movie={movie} />
            <div className="list-movie-details-container">
              <MoviePoster movie={movie} />
              <div className="movie-details">
                <MovieLabels movie={movie} />
                <MovieEmotions
                  emotions={movie.emotions}
                  emotionColors={movie.emotionColors}
                />
                <MovieButtons movie={movie} />
              </div>
            </div>
            <div className="movie-emotion"></div>
          </li>
        ))}
    </ul>
  )
}

export default MovieList

function MovieTitle({ movie }) {
  return (
    <div className="movie-title-container">
      <p className="movie-title">
        <Link to={`/movie/${movie.id}`}>{movie.title}</Link>
      </p>
    </div>
  )
}

function MoviePoster({ movie }) {
  return (
    <div className="movie-poster">
      <img
        className="img-cover"
        src={"https://image.tmdb.org/t/p/w500/" + movie.poster_path}
        alt={movie.title}
        onError={(e) => {
          e.target.onerror = null
          e.target.src = "./assets/default.png"
        }}
      />
    </div>
  )
}

function MovieLabels({ movie }) {
  return (
    <div className="labels">
      <p className="detail">
        <span className="label">Director:</span> {movie.director}
      </p>
      <p className="detail">
        <span className="label">Genre:</span> {movie.genre}
      </p>
      <p className="detail">
        <span className="label">Country:</span> {movie.country}
      </p>
      <p className="detail">
        <span className="label">Duration:</span> {movie.duration}
      </p>
      <MovieCast movie={movie} />
      <p className="detail">
        <span className="label">In your album:</span> {movie.album}
      </p>
      <p className="detail">
        <span className="label">Favorite:</span> {movie.favorite ? "Yes" : "No"}
      </p>
    </div>
  )
}

function MovieCast({ movie }) {
  return (
    <div className="detail">
      <span className="label">Cast:</span>
      {movie.cast && movie.cast.length > 0 ? (
        <ul>
          {movie.cast.slice(0, 3).map((member) => (
            <li key={member._id}>{member.name}</li>
          ))}
        </ul>
      ) : (
        <p>No cast information available</p>
      )}
    </div>
  )
}

function MovieEmotions({ emotions = [], emotionColors = [] }) {
  // Normalize: backend may send a string instead of array
  const colors = Array.isArray(emotionColors)
    ? emotionColors
    : emotionColors
    ? [emotionColors]
    : []

  if (!emotions || emotions.length === 0 || colors.length === 0) return null

  return (
    <div className="movie-emotions">
      {colors.map((color, index) => (
        <div
          className="movie-emotion"
          key={index}
          style={{ backgroundColor: color }}
        />
      ))}
    </div>
  )
}


function MovieButtons({ movie }) {
  return (
    <div className="movie-buttons">
      <Link to={`/movie/${movie.id}`} className="btn ifelt-button">
        View Profile
      </Link>
      <Link to={`/classify/${movie.id}`} className="btn ifelt-button">
        Classify
      </Link>
    </div>
  )
}
